import { userContextUpdateObservationsGroup } from 'api/observations';
import { IUpdateObservationsGroup } from 'interfaces/timeline';
import {
  displayErrorArrayNotifications,
  displaySuccessNotification,
} from 'modules/Notifications';
import { useMutationWithResultNotification } from '../useMutationWithResultNotification';

type useUpdateObservationsGroupProps = {
  userId: string;
  timelineId: string;
  successFb?: () => void;
};

function useUserContextUpdateObservationsGroup({
  userId,
  timelineId,
  successFb,
}: useUpdateObservationsGroupProps) {
  return useMutationWithResultNotification({
    asyncApiFunction: async (data: IUpdateObservationsGroup) => {
      await userContextUpdateObservationsGroup(userId, timelineId, data);
    },
    resetOnResult: true,
    onSuccess: () => {
      displaySuccessNotification(
        'TimelineDetails.ManageObservationGroupModal.success'
      );
      successFb && successFb();
    },
    onErrorArray: (errorArray) => {
      displayErrorArrayNotifications(
        errorArray,
        'TimelineDetails.ManageObservationGroupModal.error'
      );
    },
  });
}

export default useUserContextUpdateObservationsGroup;
